// extracted by mini-css-extract-plugin
export default {"wrapper":"TextChipsList_wrapper__KtuIy","input":"TextChipsList_input__dxs-P","label":"TextChipsList_label__dcx1v","likeAnimation":"TextChipsList_likeAnimation__3MxFE"};